// Logout body component for the logout page.

// Imports ----------------------------------------------------------------------------------------------------------

import LogoutBodyContainer from '@components/atoms/container/logoutBodyContainer';
import LogoutInfo from '@components/atoms/text/logoutInfo';
import LogoutTitle from '@components/atoms/text/logoutTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Constants
 */
const LITERALS = 'PAGES.SETTINGS.LOGOUT';

/**
 * Logout body component for the logout page.
 * Handles the logout information display.
 *
 * @returns {JSX.Element} Logout body component
 */
export default function LogoutBody() {
  // Render
  return (
    <LogoutBodyContainer>
      <LogoutTitle>{TranslationManager.get(`${LITERALS}.TITLE`)}</LogoutTitle>
      <LogoutInfo>{TranslationManager.get(`${LITERALS}.INFO`)}</LogoutInfo>
      <LogoutInfo>{TranslationManager.get(`${LITERALS}.ADVICE`)}</LogoutInfo>
    </LogoutBodyContainer>
  );
}
